import Script from 'next/script'

import PrivateRoute from 'components/blocks/PrivateRoute'
import TemplateBrainablePayment from 'components/brainable/TemplateBrainablePayment'
import LayoutPayment from 'components/layouts/LayoutPayment'
import {TPageComponent} from 'src/types'

interface IPaymentProps {}

const Payment: TPageComponent<IPaymentProps> = () => {
	return (
		<PrivateRoute>
			<Script
				id="flex-charge"
				strategy="afterInteractive"
				dangerouslySetInnerHTML={{
					__html: `(function (w,d,s,o,f,js,fjs) {
											w['JS-Widget']=o;w[o] = w[o] || function () { (w[o].q = w[o].q || []).push(arguments) };
											js = d.createElement(s), fjs = d.getElementsByTagName(s)[0];
											js.id = o; js.src = f; js.async = 1; fjs.parentNode.insertBefore(js, fjs);
											}(window, document, 'script', 'fc', 'https://sensejs.flex-charge.com/widget.js'));
											fc('init', '${process.env.NEXT_PUBLIC_FC_KEY1}', '${process.env.NEXT_PUBLIC_FC_KEY2}');
											window.fcInited = true;
											`,
				}}
			/>
			<TemplateBrainablePayment />
		</PrivateRoute>
	)
}

Payment.displayName = 'Payment'
Payment.Layout = LayoutPayment

export default Payment
